import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import PndApi from '../../../../utils/pnd/PndRestApi'
import VehicleTableView from './components/VehicleTableView';
import SnackbarContent from '@mui/material/SnackbarContent';
import LinearProgress from '@mui/material/LinearProgress';
import { showNotification } from 'src/shared/components/Notification';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import Badge from "react-bootstrap/Badge";
import { Box } from '@mui/material';
import PageHeader from 'src/shared/components/layout/PageHeader';
const UserIndex = () => {
  useEffect(() => {
    getAllHubVehicleDetails();
  }, [])

  const [reactTableData, setReactTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const getAllHubVehicleDetails = async () => {
    try {
      setLoading(true);
      const response = await PndApi.GetAllHubVehicleDetails();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableHeaderData: columns, tableRowsData: response.data.data });
      } else if (response?.data?.status && response?.data?.status === 204) {
        setNoRecordFound(true);
      }
      else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
        return;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };


  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 15,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },
      {
        Header: 'Plate Number',
        accessor: 'plateNo',
        disableGlobalFilter: false,
      },
      {
        Header: 'Vehicle Unique ID',
        accessor: 'vehicleUniqueId',
        disableGlobalFilter: false,
      },
      {
        Header: 'Vehicle Make',
        accessor: 'makerName',
        disableGlobalFilter: false,
      },
      {
        Header: 'Vehicle Model',
        accessor: 'modelName',
        disableGlobalFilter: false,
      },
      {
        Header: 'Vehicle Type',
        accessor: 'vehicleType',
        disableGlobalFilter: false,
      },


      {
        Header: "Opn. Status",
        accessor: "status",
        disableSortBy: true,
        Cell: ({ row }) =>
          row.original.status ? (
            <h6><Badge bg="success">ACTIVE</Badge></h6>
          ) :
            <h6><Badge bg="danger">IN-ACTIVE</Badge></h6>

      },


    ],
    [],
  );


  // return (
  //   <Container>
  //     {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) &&
  //       <VehicleTableView reactTableData={reactTableData} />}
  //     {isNoRecordFound && <VehicleTableView isNoRecordFound={isNoRecordFound} />
  //     }
  //     {isNoRecordFound && <SnackbarContent message={'No Record Found'} />}
  //     {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}

  //   </Container>
  // );

  return (
    <Box sx={{ p: 3, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <Container fluid style={{ maxWidth: '1400px' }}>
        <PageHeader
          icon={<DirectionsCarIcon fontSize="large" />}
          title="Vehicle Management"
          subtitle="View and manage fleet vehicles, plate numbers, and hub allocations."
          gradient="linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)"
        />

        {loading && <LinearProgress sx={{ mb: 2, borderRadius: 2 }} />}
        <Box sx={{ position: 'relative' }}>
          {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && !isNoRecordFound && (
            <VehicleTableView
              reactTableData={reactTableData}
              isNoRecordFound={isNoRecordFound}
            />
          )}
          {isNoRecordFound && (
            <VehicleTableView
              isNoRecordFound={isNoRecordFound}

            />
          )}
          {isNoRecordFound && <SnackbarContent message={"No Record Found"} />}
        </Box>
      </Container>
    </Box>
  );
};

export default UserIndex;